<template>
    <page-view title="项目数量统计">
        <template #action>
            <a-select v-model="year" placeholder="选择年份" size="large" style="width: 200px">
                <a-select-option v-for="y in yearArr" :key="y.year1" :value="y.year1">
                    {{y.year1}}年
                </a-select-option>
            </a-select>
        </template>

        <a-spin :spinning="spinning" tip="加载中...">
            <!-- 采购方式统计 -->
            <a-row :gutter="16" type="flex">
                <a-col :xs="24" :lg="12">
                    <a-card title="采购方式-项目数量" :bordered="false" class="chart-card mb-4">
                        <piechart ref="methodPiechart1" id="methodPiechart1" :echarStyle="{width: '100%', height: '300px'}" />
                        <div class="stat-table">
                            <div v-for="item in companyMethodData" :key="item.name" class="stat-item">
                                <span class="stat-label">{{item.name}}</span>
                                <span class="stat-value">{{item.value}}</span>
                            </div>
                        </div>
                    </a-card>
                </a-col>

                <!-- 失败项目统计 -->
                <a-col :xs="24" :lg="12">
                    <a-card title="失败项目-数量统计" :bordered="false" class="chart-card mb-4">
                        <piechart ref="projectFailPiechart" id="projectFailPiechart" :echarStyle="{width: '100%', height: '300px'}" />
                        <div class="stat-table">
                            <div v-for="item in companyProjectFailData" :key="item.name" class="stat-item">
                                <span class="stat-label">{{item.name}}</span>
                                <span class="stat-value">{{item.value}}</span>
                            </div>
                        </div>
                    </a-card>
                </a-col>

                <!-- 标的类型统计 -->
                <a-col :xs="24" :lg="12">
                    <a-card title="货物、工程、服务-项目数量" :bordered="false" class="chart-card mb-4">
                        <piechart ref="TenderTypePiechart1" id="TenderTypePiechart1" :echarStyle="{width: '100%', height: '300px'}" />
                        <div class="stat-table">
                            <div v-for="item in companyTenderTypeData" :key="item.name" class="stat-item">
                                <span class="stat-label">{{item.name}}</span>
                                <span class="stat-value">{{item.value}}</span>
                            </div>
                        </div>
                    </a-card>
                </a-col>

                <!-- 项目类型统计 -->
                <a-col :xs="24" :lg="12">
                    <a-card title="政府采购、非政府采购-项目数量" :bordered="false" class="chart-card mb-4">
                        <piechart ref="XmlxPiechart1" id="XmlxPiechart1" :echarStyle="{width: '100%', height: '300px'}" />
                        <div class="stat-table">
                            <div v-for="item in companyXmlxData" :key="item.name" class="stat-item">
                                <span class="stat-label">{{item.name}}</span>
                                <span class="stat-value">{{item.value}}</span>
                            </div>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
          <a-row :gutter="16" type="flex">
            <a-col :xs="24" :lg="12">
            <!-- 标的类型金额统计 -->
            <a-card title="货物、工程、服务-总预算金额、中标成交金额" :bordered="false" class="chart-card mb-4">
                <multi-barchart ref="jeMultiBarchart1" id="jeMultiBarchart1" :echarStyle="{width: '100%', height: '300px'}" />
                <a-table
                    :columns="tenderTypeJeColumns"
                    :data-source="companyTenderTypeJeData"
                    :pagination="false"
                    :scroll="{ x: 600 }"
                    row-key="tenderType"
                    bordered
                    size="small">
                    <template #zysje="text"><span class="money-text">¥{{text|NumberFormat2}}</span></template>
                    <template #zbje="text"><span class="money-text money-received">¥{{text|NumberFormat2}}</span></template>
                </a-table>
            </a-card>
              </a-col>
            <a-col :xs="24" :lg="12">
            <!-- 项目类型金额统计 -->
            <a-card title="政府项目、非政府项目-总预算金额、中标成交金额" :bordered="false" class="chart-card mb-4">
                <multi-barchart ref="jeMultiBarchart2" id="jeMultiBarchart2" :echarStyle="{width: '100%', height: '300px'}" />
                <a-table
                    :columns="xmlxJeColumns"
                    :data-source="companyXmlxJeData"
                    :pagination="false"
                    :scroll="{ x: 600 }"
                    row-key="xmlx"
                    bordered
                    size="small">
                    <template #zysje="text"><span class="money-text">¥{{text|NumberFormat2}}</span></template>
                    <template #zbje="text"><span class="money-text money-received">¥{{text|NumberFormat2}}</span></template>
                </a-table>
            </a-card>
          </a-col>
          </a-row>
            <!-- 部门项目数量统计 -->
            <a-row :gutter="16" type="flex">
                <a-col :xs="24" :lg="12">
                    <a-card title="部门-项目数量" :bordered="false" class="chart-card mb-4">
                        <multi-barchart ref="xmslMultiBarchart2" id="xmslMultiBarchart2" :echarStyle="{width: '100%', height: '300px'}" />
                        <a-table
                            :columns="deptColumns"
                            :data-source="deptData"
                            :pagination="false"
                            :scroll="{ x: 600 }"
                            row-key="tenderDept"
                            bordered
                            size="small">
                            <template #xmsl="text"><a-tag color="blue">{{text}}</a-tag></template>
                        </a-table>
                    </a-card>
                </a-col>

                <!-- 部门金额统计 -->
                <a-col :xs="24" :lg="12">
                    <a-card title="部门-总预算金额、中标成交金额" :bordered="false" class="chart-card mb-4">
                        <multi-barchart ref="xmslMultiBarchart3" id="xmslMultiBarchart3" :echarStyle="{width: '100%', height: '300px'}" />
                        <a-table
                            :columns="deptJeColumns"
                            :data-source="deptXmlxJeData"
                            :pagination="false"
                            :scroll="{ x: 600 }"
                            row-key="tenderDept"
                            bordered
                            size="small">
                            <template #zysje="text"><span class="money-text">¥{{text|NumberFormat2}}</span></template>
                            <template #zbje="text"><span class="money-text money-received">¥{{text|NumberFormat2}}</span></template>
                        </a-table>
                    </a-card>
                </a-col>
            </a-row>
        </a-spin>
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import Piechart from './Piechart'
import MultiBarchart from './MultiBarchart'
import moment from 'moment'

export default {
    name: 'ProjectStatisticsIndexXmsl',
    components: { PageView, Piechart, MultiBarchart },
    data() {
        return {
            spinning: true,
            companyMethodData: [],
            companyTenderTypeData: [],
            companyProjectFailData: [],
            companyXmlxData: [],
            companyXmlxJeData: [],
            companyTenderTypeJeData: [],
            deptData: [],
            deptXmlxJeData: [],
            yearArr: [],
            year: String(moment().year() - 1),
            tenderTypeJeColumns: [
                { title: '标的类型', dataIndex: 'tenderType', key: 'tenderType', width: 150, align: 'center' },
                { title: '总预算金额', dataIndex: 'zysje', key: 'zysje', width: 150, scopedSlots: { customRender: 'zysje' }, align: 'right' },
                { title: '中标成交金额', dataIndex: 'zbje', key: 'zbje', width: 150, scopedSlots: { customRender: 'zbje' }, align: 'right' }
            ],
            xmlxJeColumns: [
                { title: '项目类型', dataIndex: 'xmlx', key: 'xmlx', width: 200, align: 'center' },
                { title: '总预算金额', dataIndex: 'zysje', key: 'zysje', width: 150, scopedSlots: { customRender: 'zysje' }, align: 'right' },
                { title: '中标成交金额', dataIndex: 'zbje', key: 'zbje', width: 150, scopedSlots: { customRender: 'zbje' }, align: 'right' }
            ],
            deptColumns: [
                { title: '部门', dataIndex: 'tenderDept', key: 'tenderDept', width: 150, align: 'center' },
                { title: '项目数量', dataIndex: 'xmsl', key: 'xmsl', width: 120, scopedSlots: { customRender: 'xmsl' }, align: 'center' }
            ],
            deptJeColumns: [
                { title: '部门', dataIndex: 'tenderDept', key: 'tenderDept', width: 150, align: 'center' },
                { title: '总预算金额', dataIndex: 'zysje', key: 'zysje', width: 150, scopedSlots: { customRender: 'zysje' }, align: 'right' },
                { title: '中标成交金额', dataIndex: 'zbje', key: 'zbje', width: 150, scopedSlots: { customRender: 'zbje' }, align: 'right' }
            ]
        }
    },
    created() {
        this.initMethodDataCompany()
        this.initTenderTypeDataCompany()
        this.initXmlxDataCompany()
        this.initJeByTenderTypeCompany()
        this.initJeByXmlxCompany()
        this.initDataDept()
        this.initJeByXmlxDept()
        this.initYearData()
        this.initProjectFailDataCompany()
    },
    watch: {
        year() {
            this.initMethodDataCompany()
            this.initTenderTypeDataCompany()
            this.initXmlxDataCompany()
            this.initJeByTenderTypeCompany()
            this.initJeByXmlxCompany()
            this.initDataDept()
            this.initJeByXmlxDept()
            this.initProjectFailDataCompany()
        }
    },
    methods: {
        async initYearData() {
            try {
                const res = await this.$http.get('/api/1/bidApply/statistics/getYears.json')
                this.yearArr = res.result
            } catch (e) {}
        },
        async initMethodDataCompany() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getXmslByMethod.json?year=${this.year}`)
                this.companyMethodData = res.result
                this.$nextTick(() => {
                    if (this.$refs.methodPiechart1) {
                        this.$refs.methodPiechart1.refreshData([], res.result, '采购方式-项目数量',{
                          alignTo: 'edge', // 标签对齐方式，edge表示对齐到饼图边缘
                          formatter: "{b}{c}({d}%)", // 标签格式化器：{b}=数据名, {c}=数值, {d}=百分比，使用\n换行
                          minMargin: 10, // 标签与饼图边缘的最小间距
                          edgeDistance: 20, // 标签距离边缘的距离
                          lineHeight: 18,} // 标签行高，多行文本时的行间距
                        )
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initTenderTypeDataCompany() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getXmslByTenderType.json?year=${this.year}`)
                this.companyTenderTypeData = res.result
                this.$nextTick(() => {
                    if (this.$refs.TenderTypePiechart1) {
                        this.$refs.TenderTypePiechart1.refreshData([], res.result, '货物、工程、服务-项目数量')
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initXmlxDataCompany() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getXmslByXmlx.json?year=${this.year}`)
                this.companyXmlxData = res.result
                this.$nextTick(() => {
                    if (this.$refs.XmlxPiechart1) {
                        this.$refs.XmlxPiechart1.refreshData([], res.result, '政府采购、非政府采购-项目数量')
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initProjectFailDataCompany() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getXmslByProjectFail.json?year=${this.year}`)
                this.companyProjectFailData = res.result
                this.$nextTick(() => {
                    if (this.$refs.projectFailPiechart) {
                        this.$refs.projectFailPiechart.refreshData([], res.result, '失败项目统计')
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initJeByTenderTypeCompany() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getJeByTenderTypeCompany.json?year=${this.year}`)
                this.companyTenderTypeJeData = res.result
                const xAxisData = res.result.map(d => d.tenderType)
                const sourcesData = [
                    { name: '总预算金额', data: res.result.map(d => d.zysje) },
                    { name: '总中标金额', data: res.result.map(d => d.zbje) }
                ]
                this.$nextTick(() => {
                    if (this.$refs.jeMultiBarchart1) {
                        this.$refs.jeMultiBarchart1.refreshData(sourcesData, xAxisData)
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initJeByXmlxCompany() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getJeByXmlxCompany.json?year=${this.year}`)
                this.companyXmlxJeData = res.result
                const xAxisData = res.result.map(d => d.xmlx)
                const sourcesData = [
                    { name: '总预算金额', data: res.result.map(d => d.zysje) },
                    { name: '总中标金额', data: res.result.map(d => d.zbje) }
                ]
                this.$nextTick(() => {
                    if (this.$refs.jeMultiBarchart2) {
                        this.$refs.jeMultiBarchart2.refreshData(sourcesData, xAxisData)
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initDataDept() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getXmslByDept.json?year=${this.year}`)
                this.deptData = res.result
                const xAxisData = res.result.map(d => d.tenderDept)
                const sourcesData = [{ name: '项目数量', unit: '个', data: res.result.map(d => d.xmsl) }]
                this.$nextTick(() => {
                    if (this.$refs.xmslMultiBarchart2) {
                        this.$refs.xmslMultiBarchart2.refreshData(sourcesData, xAxisData)
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        async initJeByXmlxDept() {
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getJeByDept.json?year=${this.year}`)
                this.deptXmlxJeData = res.result
                const xAxisData = res.result.map(d => d.tenderDept)
                const sourcesData = [
                    { name: '总预算金额', data: res.result.map(d => d.zysje) },
                    { name: '总中标金额', data: res.result.map(d => d.zbje) }
                ]
                this.$nextTick(() => {
                    if (this.$refs.xmslMultiBarchart3) {
                        this.$refs.xmslMultiBarchart3.refreshData(sourcesData, xAxisData)
                    }
                })
            } finally {
                this.spinning = false
            }
        }
    }
}
</script>

<style scoped lang="less">
// 图表卡片
.chart-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    height: 98%; // 确保卡片填满列的高度
    &:hover { box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12); }
    .ant-card-head { border-bottom: 1px solid #f0f0f0; }
    .ant-card-head-title { font-size: 16px; font-weight: 600; }
    .ant-card-body {
        display: flex;
        flex-direction: column;
        flex: 1; // 让卡片body填充剩余空间
    }
}

// 图表容器
.chart-card .ant-card-body > div:first-child {
    flex: 0 0 auto;
}

// 统计表格（饼图下方）
.stat-table {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 0;
    justify-content: center;
    align-content: flex-start;
    margin-top: auto; // 推到底部
}
.stat-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background: #f5f5f5;
    border-radius: 4px;
    flex-shrink: 0;
}
.stat-label { font-weight: 500; color: #666; }
.stat-value { font-weight: 600; color: #1890ff; }

// 表格样式
.money-text { font-family: 'Consolas', 'Monaco', monospace; font-weight: 600; }
.money-received { color: #52c41a; }
.ant-table-tbody > tr:hover > td { background-color: #f5f5f5 !important; }
.ant-tag { font-weight: 500; }
.mb-4 { margin-bottom: 16px; }

// 响应式
@media (max-width: 768px) {
    .stat-table { flex-direction: column; }
    .stat-item { width: 100%; }
}
</style>
